const navLinkConfirmCreateUser = {
  text: 'Volte para página inicial para entrar'
};

export default navLinkConfirmCreateUser;
